import { lazy } from "react";
import { Route } from "react-router-dom";
import Protected from "@/components/Protected";

const DoctorAppointments  = lazy(() => import("@/pages/DoctorAppointments"));
const DoctorWaitingRoom   = lazy(() => import("@/pages/DoctorWaitingRoom"));
const DoctorConsultations = lazy(() => import("@/pages/DoctorConsultations"));
const DoctorAuthorizedPatients = lazy(() => import("@/pages/DoctorAuthorizedPatients"));
const DoctorClinicalDocs  = lazy(() => import("@/pages/DoctorClinicalDocs"));
const DoctorPrescriptions = lazy(() => import("@/pages/DoctorPrescriptions"));
const DoctorLabOrders     = lazy(() => import("@/pages/DoctorLabOrders"));
const DoctorEarnings      = lazy(() => import("@/pages/DoctorEarnings"));
const Messages            = lazy(() => import("@/pages/Messages"));

const DoctorDashboard     = lazy(() => import("@/pages/DoctorDashboard"));
const DoctorProfile       = lazy(() => import("@/pages/DoctorProfile"));
const DoctorChart         = lazy(() => import("@/pages/DoctorChart"));
const DoctorConsultation  = lazy(() => import("@/pages/DoctorConsultation"));
const ConsultationComplete = lazy(() => import("@/pages/ConsultationComplete"));
const DoctorAvailability  = lazy(() => import("@/pages/DoctorAvailability"));
const DoctorResultsReview = lazy(() => import("@/pages/DoctorResultsReview"));
const DoctorNotificationPrefs = lazy(() => import("@/pages/DoctorNotificationPrefs"));

const D = ["doctor"];

export default (
  <>
    {/* Shell */}
    <Route path="/doctor"                 element={<Protected roles={D}><DoctorDashboard /></Protected>} />
    <Route path="/doctor/appointments"    element={<Protected roles={D}><DoctorAppointments /></Protected>} />
    <Route path="/doctor/waiting-room"    element={<Protected roles={D}><DoctorWaitingRoom /></Protected>} />
    <Route path="/doctor/consultations"   element={<Protected roles={D}><DoctorConsultations /></Protected>} />
    <Route path="/doctor/patients"        element={<Protected roles={D}><DoctorAuthorizedPatients /></Protected>} />
    <Route path="/doctor/clinical-docs"   element={<Protected roles={D}><DoctorClinicalDocs /></Protected>} />
    <Route path="/doctor/prescriptions"   element={<Protected roles={D}><DoctorPrescriptions /></Protected>} />
    <Route path="/doctor/lab-orders"      element={<Protected roles={D}><DoctorLabOrders /></Protected>} />
    <Route path="/doctor/messages"        element={<Protected roles={D}><Messages /></Protected>} />
    <Route path="/doctor/earnings"        element={<Protected roles={D}><DoctorEarnings /></Protected>} />

    {/* Legacy clinical workflows */}
    <Route path="/doctor/profile"         element={<Protected roles={D}><DoctorProfile /></Protected>} />
    <Route path="/doctor/chart/:patient_user_id" element={<Protected roles={D}><DoctorChart /></Protected>} />
    <Route path="/doctor/consultation/:id" element={<Protected roles={D}><DoctorConsultation /></Protected>} />
    <Route path="/doctor/consultation/:id/complete" element={<Protected roles={D}><ConsultationComplete /></Protected>} />
    <Route path="/doctor/availability"    element={<Protected roles={D}><DoctorAvailability /></Protected>} />
    <Route path="/doctor/results"         element={<Protected roles={D}><DoctorResultsReview /></Protected>} />
    <Route path="/doctor/settings/notifications" element={<Protected roles={D}><DoctorNotificationPrefs /></Protected>} />
  </>
);
